import { render, staticRenderFns } from "./PurchasedSkill.vue?vue&type=template&id=e518931a&scoped=true"
import script from "./PurchasedSkill.vue?vue&type=script&lang=js"
export * from "./PurchasedSkill.vue?vue&type=script&lang=js"
import style0 from "./PurchasedSkill.vue?vue&type=style&index=0&id=e518931a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e518931a",
  null
  
)

export default component.exports